import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../../services/validation/rules/validationRules'

export const webViewPropertyOwnerHouseSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    room: validationRules.room,
    livingSpace: validationRules.livingSpace,
    plotArea: validationRules.plotArea,
    startRentalDate: validationRules.startRentalDateRequired,
  },
  costs: {
    price: usePurchasePriceOnRequestCondition,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  objectDetails: {
    totalFloorsNumber: validationRules.totalFloors,
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    usableArea: validationRules.usableArea,
  },
  otherFacilities: {
    rentalIncome: validationRules.rentalIncome,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
}
